import React, { useState } from 'react'
import CalendarListing from './CalendarListing'

export default function CalendarList({ title, calendars, canEdit=true }){
  const [ collapsed, setCollapsed ] = useState(true)

  return(
      <div className="pt-3 pb-2">
        <div onClick={() => setCollapsed(!collapsed)} className="d-flex justify-content-between align-items-center cursor-pointer">
          <div className="pb-2 pt-1 font-weight-bold unselectable">{title}</div>
          <div className={`fas ${ collapsed ? 'fa-caret-down' : 'fa-caret-left'}`} />
        </div>
        {
          calendars.map( calendar => <CalendarListing canEdit={canEdit} visible={collapsed} key={calendar.id} listing={calendar}/> )
        }
      </div>
  )
}